module.exports = __webpack_public_path__ + "static/cashback-banner-2-0f9ee02f40ca1b5d8f2f99df67a9c871.png";